import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import * as Moment from 'moment';

import { NgbDateCustomFormatter } from './@Utils';

@Component({
  selector: 'input-datetime-content',
  template: `
<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <!-- 
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
  -->
</div>
<div class="card-body">
  <!-- <form class="form-inline mb-3"> -->
    <div class="form-group">
      <br>
      <div class="input-group datepicker-input">
      <input class="form-control" placeholder="YYYY/MM/DD" [(ngModel)]="inputDate" ngbDatepicker #d="ngbDatepicker" style="background-color: antiquewhite" readonly>
        <button class="input-group-addon" (click)="d.toggle()" type="button">
          <span class="fa fa-calendar"></span>
        </button>
      </div>
      <br>
      <div class="toggle-example" style="display: flex">
        <input class="form-control" placeholder="MM:SS" [format]="24"
          [ngxTimepicker]="inputTimePicker1" [(ngModel)]="inputTime1"
          [disableClick]="true" style="background-color: antiquewhite; width:100px" readonly>
        <ngx-material-timepicker-toggle [for]="inputTimePicker1"></ngx-material-timepicker-toggle>
        <ngx-material-timepicker #inputTimePicker1 [minutesGap]="30"></ngx-material-timepicker>
        〜
        <input class="form-control" placeholder="MM:SS" [format]="24"
          [ngxTimepicker]="inputTimePicker2" [(ngModel)]="inputTime2"
          [disableClick]="true" style="background-color: antiquewhite; width:100px" readonly>
        <ngx-material-timepicker-toggle [for]="inputTimePicker2"></ngx-material-timepicker-toggle>
        <ngx-material-timepicker #inputTimePicker2 [minutesGap]="30"></ngx-material-timepicker>
      </div>
    </div>
    <font color=red size=2 style="vertical-align:top">{{validateMessage}}</font>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary mr-auto" (click)="activeModal.close('cancel')">キャンセル</button>
  <button class="btn btn-primary"  (click)="clickOK()">OK</button>
</div>
`,
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomFormatter },
  ]
})
export class InputDateTimeContent {
  @Input() title;
  @Input() validateMessage;
  private inputDate: NgbDateStruct;
  private inputTime1: string;
  private inputTime2: string;

  constructor(public activeModal: NgbActiveModal) { }

  set inputDateTime1(value: Date) {
    this.inputDate = {
      year: value.getFullYear(),
      month: value.getMonth() + 1,    // Date型の月は0オリジンのため、1プラス
      day: value.getDate(),
    };
    this.inputTime1 = Moment(value).format("HH:mm");
  }
  get inputDateTime1(): Date {
    return new Date(this.inputDate.year + "/" + this.inputDate.month + "/" + this.inputDate.day + " " + this.inputTime1);
  }

  set inputDateTime2(value: Date) {
    this.inputTime2 = Moment(value).format("HH:mm");
  }
  get inputDateTime2(): Date {
    return new Date(this.inputDate.year + "/" + this.inputDate.month + "/" + this.inputDate.day + " " + this.inputTime2);
  }

  private async clickOK() {
    // エラーチェック（未入力、時間の逆転などはエラーとする）
    if (this.inputDateTime1 >= this.inputDateTime2) {
      this.validateMessage = "時間を正しく指定してください。";
      return false;
    }
    else if (this.inputTime1 == "" || this.inputTime2 == "") {
      this.validateMessage = "時間を正しく指定してください。";
      return false;
    }
    this.activeModal.close('ok');
  }

}
